function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Menu/Iconen/Admin-berichten-blauw",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  fill: "#425CD4"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0,29.862069 L29.7931034,29.862069 L29.7931034,-4.90029473e-15 L0,-4.90029473e-15 L0,29.862069 Z M0.551724138,29.31 L29.2413793,29.31 L29.2413793,0.517241379 L0.551724138,0.517241379 L0.551724138,29.31 Z",
  id: "Fill-1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.55165517,25.9655172 L6.55165517,3.89655172 L17.862,3.89655172 L17.862,9.27586207 L23.2413103,9.27586207 L23.2413103,25.9655172 L6.55165517,25.9655172 Z M18.4137241,4.27586207 L22.862,8.72413793 L18.4137241,8.72413793 L18.4137241,4.27586207 Z M23.7930345,8.89655172 L18.2413103,3.34482759 L5.99993103,3.34482759 L5.99993103,26.5172414 L23.7930345,26.5172414 L23.7930345,8.89655172 Z",
  id: "Fill-2"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-3",
  points: "9.13793103 23.6551724 20.6551724 23.6551724 20.6551724 23.1034483 9.13793103 23.1034483"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-4",
  points: "9.13793103 20.8965517 20.6551724 20.8965517 20.6551724 20.3448276 9.13793103 20.3448276"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-5",
  points: "9.13793103 18.137931 20.6551724 18.137931 20.6551724 17.5862069 9.13793103 17.5862069"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-6",
  points: "9.13793103 15.3793103 20.6551724 15.3793103 20.6551724 14.8275862 9.13793103 14.8275862"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.82758621,8.86206897 L13.6206897,8.86206897 L13.6206897,6.65517241 L9.82758621,6.65517241 L9.82758621,8.86206897 Z M9.27586207,9.37931034 L14.1724138,9.37931034 L14.1724138,6.06896552 L9.27586207,6.06896552 L9.27586207,9.37931034 Z",
  id: "Fill-7"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Fill-8",
  points: "9.13793103 12.4827586 20.6551724 12.4827586 20.6551724 11.9310345 9.13793103 11.9310345"
})));
function SvgDocumentsBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Menu/Iconen/Admin berichten blauw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsBlue);
export default __webpack_public_path__ + "static/media/documents_blue.697d854c801c2a367bef4a986d4a3e29.svg";
export { ForwardRef as ReactComponent };